<template>
  <div class="element-input">
    <Input :placeholder="placeholder||''" :type="type" v-if="!readonly" v-model="currentValue" @on-change="change" @on-blur="inputBlur" :disabled='disabled'></Input>
    <label v-else>{{currentValue}}</label>
  </div>
</template>

<script>
export default {
  name: 'elementInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  created () {
    this.currentValue = this.value;
  },
  watch: {
    value: function (val) {
      this.currentValue = val;
    }
  },
  methods: {
    change () {
      this.$emit('input', this.currentValue);
      this.$emit('on-change');
    },
    inputBlur () {
      this.$emit('on-blur');
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/input.vue